import { useMutation } from '@tanstack/react-query';
import api from '@pasqal/core/api';
import type { DeviceType } from '~/api/types';

interface SendBatchParams {
  sequence: string;
  project_id: string;
  emulator: DeviceType;
  job_runs: number;
}

export const useSendBatch = () => {
  return useMutation({
    mutationFn: ({
      sequence,
      project_id,
      job_runs,
      emulator
    }: SendBatchParams) =>
      api.batches.createBatch({
        sequence_builder: sequence,
        project_id,
        emulator,
        jobs: [{ runs: job_runs }]
      })
  });
};
